var _mask, _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWord(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 0,
    width: 18,
    height: 24
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 2C3 0.89543 3.89543 0 5 0H15V4C15 5.10457 15.8954 6 17 6H21V22C21 23.1046 20.1046 24 19 24H5C3.89543 24 3 23.1046 3 22V2Z",
    fill: "#47A7FF"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M3 2C3 0.89543 3.89543 0 5 0H15V4C15 5.10457 15.8954 6 17 6H21V22C21 23.1046 20.1046 24 19 24H5C3.89543 24 3 23.1046 3 22V2Z",
    fill: "#47A7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 11.5C8 11.2239 8.22386 11 8.5 11H15.5C15.7761 11 16 11.2239 16 11.5V11.8333C16 12.1095 15.7761 12.3333 15.5 12.3333H8.5C8.22386 12.3333 8 12.1095 8 11.8333V11.5Z",
    fill: "#47A7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 14.1667C8 13.8905 8.22386 13.6667 8.5 13.6667H15.5C15.7761 13.6667 16 13.8905 16 14.1667V14.5C16 14.7761 15.7761 15 15.5 15H8.5C8.22386 15 8 14.7761 8 14.5V14.1667Z",
    fill: "#47A7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5 16.3333C8.22386 16.3333 8 16.5572 8 16.8333V17.1667C8 17.4428 8.22386 17.6667 8.5 17.6667H11.5C11.7761 17.6667 12 17.4428 12 17.1667V16.8333C12 16.5572 11.7761 16.3333 11.5 16.3333H8.5Z",
    fill: "#47A7FF"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 4V0L21 6H17C15.8954 6 15 5.10457 15 4Z",
    fill: "#47A7FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWord);
export default __webpack_public_path__ + "static/media/Word.c9c857896d3cb2ae84301c922a917b37.svg";
export { ForwardRef as ReactComponent };